"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[97968,22746],{

/***/ 603626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ InputSlider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(285212);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(640128);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const InputSlider = (_a) => {
  var _b = _a, {
    range,
    min = 0,
    max = 100,
    value,
    defaultValue,
    onChange,
    disabled,
    step = 1,
    ref,
    tipFormatter,
    size = _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.m */ .mO.m,
    color = "primary",
    tooltip = true,
    changeOn = "dragging"
  } = _b, props = __objRest(_b, [
    "range",
    "min",
    "max",
    "value",
    "defaultValue",
    "onChange",
    "disabled",
    "step",
    "ref",
    "tipFormatter",
    "size",
    "color",
    "tooltip",
    "changeOn"
  ]);
  var _a2, _b2, _c;
  const valueDefault = defaultValue ? defaultValue : range ? [min, max] : min;
  const valueSlider = value !== void 0 ? value : valueDefault;
  const innerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const trackFillRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const tooltipRefs = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([null, null]);
  const thumbRefs = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([null, null]);
  const mouseMoveEventRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const mouseUpEventRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const percents = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(getPercent(max, min, valueSlider));
  const currentPercent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const isDragging = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  const formatter = (value2) => {
    if (value2 === void 0)
      return "";
    if (tipFormatter)
      return tipFormatter(value2);
    return new Intl.NumberFormat("en-CA", {
      maximumFractionDigits: 10
    }).format(value2);
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => () => {
    document.removeEventListener("mousemove", mouseMoveEventRef.current || (() => {
    }));
    document.removeEventListener("mouseup", mouseUpEventRef.current || (() => {
    }));
    document.removeEventListener("touchmove", mouseMoveEventRef.current || (() => {
    }));
    document.removeEventListener("touchend", mouseUpEventRef.current || (() => {
    }));
  }, []);
  const clickInTrack = (e) => {
    var _a3;
    e.stopPropagation();
    const { pageX } = getPosition(e);
    const { left = 0, width } = ((_a3 = innerRef.current) == null ? void 0 : _a3.getBoundingClientRect()) || {};
    if (!width) {
      return;
    }
    const newValue = (Number(pageX || left) - left) / width * 100;
    const [currentLeft, currentRight] = percents.current;
    const [deltaLeft, deltaRight] = [
      newValue - currentLeft,
      currentRight - newValue
    ];
    const activeIndex = range && deltaLeft < deltaRight ? 0 : 1;
    setPositions(pageX, activeIndex);
    setTooltipVisible(activeIndex, "visible");
    changeValue();
  };
  const onStartMove = (e, index) => {
    e.stopPropagation();
    currentPercent.current = percents.current[index];
    const onMouseMove = (event) => {
      isDragging.current = true;
      const { pageX: moveX } = getPosition(event);
      setPositions(moveX, index);
    };
    const onMouseUp = () => {
      setTooltipVisible(index, "hidden");
      document.removeEventListener("mouseup", onMouseUp);
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("touchend", onMouseUp);
      document.removeEventListener("touchmove", onMouseMove);
      changeOn === "dragend" && changeValue();
      mouseMoveEventRef.current = null;
      mouseUpEventRef.current = null;
      isDragging.current = false;
      currentPercent.current = null;
    };
    document.addEventListener("mouseup", onMouseUp);
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("touchend", onMouseUp);
    document.addEventListener("touchmove", onMouseMove);
    mouseMoveEventRef.current = onMouseMove;
    mouseUpEventRef.current = onMouseUp;
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (percents.current === void 0 || valueSlider === void 0)
      return;
    const [leftPercent, rightPercent] = getPercent(max, min, valueSlider);
    if (percents.current[0] === leftPercent && percents.current[1] === rightPercent) {
      return;
    }
    percents.current = [leftPercent, rightPercent];
    determinePosition(rightPercent - leftPercent, leftPercent);
  }, [valueSlider.toString(), max, min, range]);
  const getValue = (percent) => {
    const value2 = percent * (max - min) / 100;
    const v = Math.round(value2 / step) * step;
    const displayValue = Math.round(v * 100) / 100 + min;
    return displayValue > max ? max : displayValue;
  };
  const setPositions = (pageX = 0, index = null) => {
    var _a3;
    const { left = 0, width } = ((_a3 = innerRef.current) == null ? void 0 : _a3.getBoundingClientRect()) || {};
    if (!width) {
      return;
    }
    const newValue = (Number(pageX || left) - left) / width * 100;
    changePercent(newValue, index);
    changeOn === "dragging" && changeValue();
  };
  const determinePosition = (percent, leftPercent) => {
    if (trackFillRef.current) {
      trackFillRef.current.style.width = `${percent}%`;
      trackFillRef.current.style.left = `${leftPercent}%`;
    }
    if (thumbRefs.current && tooltipRefs.current) {
      percents.current.forEach((pos, index) => {
        if (thumbRefs.current[index]) {
          thumbRefs.current[index].style.left = `calc(${pos}% ${pos === 100 ? `- ${sizes[size].thumb / 2}px` : ""})`;
        }
        if (tooltipRefs.current[index]) {
          tooltipRefs.current[index].innerText = formatter(getValue(pos));
        }
      });
    }
  };
  const changeValue = () => {
    const [_left, _right] = percents.current;
    const newValues = [getValue(_left), getValue(_right)];
    if (newValues.toString() === valueSlider.toString())
      return;
    onChange == null ? void 0 : onChange(range ? newValues : newValues[1]);
  };
  const changePercent = (value2, index = null) => {
    let newValue = value2;
    const ltr = newValue - (currentPercent.current || 0) > 0;
    if (percents.current) {
      let [thumbLeft, thumbRight] = percents.current;
      if (ltr && getValue(newValue) > getValue(thumbRight) && index === 0) {
        return;
      }
      if (!ltr && getValue(newValue) < getValue(thumbLeft) && index === 1) {
        return;
      }
      if (newValue >= 100) {
        newValue = 100;
      }
      if (newValue <= 0) {
        newValue = 0;
      }
      if (index === null) {
        const middle = (thumbLeft + thumbRight) / 2;
        currentPercent.current = newValue;
        if (newValue > middle || !range) {
          thumbRight = newValue;
        } else {
          thumbLeft = newValue;
        }
        percents.current = [thumbLeft, thumbRight];
      } else {
        percents.current[index] = newValue;
      }
      const [_left, _right] = percents.current;
      const percent = _right - _left;
      determinePosition(percent, _left);
    }
  };
  const setTooltipVisible = (index, value2) => {
    if (tooltipRefs.current[index])
      tooltipRefs.current[index].style.visibility = value2;
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SliderWrapper, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    ref: innerRef,
    size,
    color,
    onMouseDown: clickInTrack
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SliderTrack, {
    className: "slider-track"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SliderTrackFill, {
    className: "slider-track-fill",
    ref: trackFillRef,
    style: {
      width: `${((_a2 = percents.current) == null ? void 0 : _a2[1]) - ((_b2 = percents.current) == null ? void 0 : _b2[0])}%`,
      left: `${(_c = percents.current) == null ? void 0 : _c[0]}%`
    }
  })), [...Array(2)].map((_, index) => {
    var _a3;
    return !range && index == 0 ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StylerThumb, {
      key: index,
      className: "slider-thumb",
      ref: (e) => {
        thumbRefs.current[index] = e;
      },
      style: {
        left: `${(_a3 = percents.current) == null ? void 0 : _a3[index]}%`
      },
      onMouseDown: (e) => onStartMove(e, index),
      onTouchStart: (e) => onStartMove(e, index),
      onMouseMove: () => !isDragging.current && setTooltipVisible(index, "visible"),
      onTouchMove: () => !isDragging.current && setTooltipVisible(index, "visible"),
      onMouseOut: () => !isDragging.current && setTooltipVisible(index, "hidden"),
      onTouchCancel: () => !isDragging.current && setTooltipVisible(index, "hidden"),
      role: "slider"
    }, tooltip && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyleTooltip, {
      className: "tooltip",
      ref: (e) => tooltipRefs.current[index] = e
    }, formatter(getValue(percents.current[index]))));
  })));
};
InputSlider.displayName = "InputSlider";
const SliderWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .CommonStyles */ .F};
  padding: 0.5rem 0;
`;
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div(({ theme, size, color }) => `
  position: relative;
  height: ${sizes[size || _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.m */ .mO.m].height}px;
  width: 100%;

  & >.slider-track .slider-track-fill {
     background-color: ${theme.colors[color] || color};
  }

  & >.slider-thumb{
    box-shadow: 0px 0px 0px 1.5px ${theme.colors[color] || color} inset;
    width: ${sizes[size || _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.m */ .mO.m].thumb}px;
    height:  ${sizes[size || _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.m */ .mO.m].thumb}px;
  }
`);
const SliderTrack = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  position: relative;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background};
  height: 100%;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
`;
const SliderTrackFill = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  position: absolute;
  top: 0;
  height: 100%;
`;
const StylerThumb = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div(({ theme }) => `
  position: absolute;
  border-radius: 1000px;
  top: 0;
  transform: translate(-25%, -50%);
  background-color: ${theme.colors.white};
  text-align: center;
  cursor: pointer;
  top: 50%
`);
const StyleTooltip = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].span(({ theme }) => `
  visibility: hidden;
  background-color: ${theme.colors.black};
  color: #fff;
  text-align: center;
  padding: 2px 3px;
  position: absolute;
  z-index: 1;
  font-size: 0.625rem;
  border-radius: 3px;
  transform: translate(-50%, -150%);
  min-width: 1.25rem;
  user-select: none;
  // arrow
  &:after {
    content: '';
    width: 8px;
    height: 5px;
    bottom: -5px;
    border-top: 4px solid ${theme.colors.black};
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
  }
`);
const sizes = {
  xs: {
    height: 3,
    thumb: 9
  },
  s: {
    height: 4,
    thumb: 11
  },
  m: { height: 5, thumb: 12 },
  l: { height: 7, thumb: 15 },
  xl: { height: 4, thumb: 20 }
};
function getPosition(e) {
  const obj = "touches" in e ? e.touches[0] : e;
  return { pageX: obj.pageX, pageY: obj.pageY };
}
const getPercent = (max, min, valueSlider) => {
  let leftValue = min, rightValue = max;
  if (typeof valueSlider === "number") {
    rightValue = valueSlider;
  } else {
    [leftValue, rightValue] = valueSlider;
  }
  let [leftPercent, rightPercent] = [
    (leftValue - min) / (max - min) * 100,
    (rightValue - min) / (max - min) * 100
  ];
  if (leftPercent < 0 || leftPercent == void 0)
    leftPercent = 0;
  if (rightPercent > 100 || rightPercent == void 0)
    rightPercent = 100;
  return [leftPercent, rightPercent];
};




/***/ }),

/***/ 622746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ ForwardOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ForwardOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M8.5 19L15.5 12L8.5 5",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 605078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ PriceFilter; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(603626);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(853675);
/* harmony import */ var _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(285212);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(917709);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PriceFilter = (_a) => {
  var _b = _a, {
    value,
    step = 1,
    onFilter,
    max,
    min
  } = _b, props = __objRest(_b, [
    "value",
    "step",
    "onFilter",
    "max",
    "min"
  ]);
  const margin = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    const newMargin = __spreadValues({}, value);
    if ((value == null ? void 0 : value.lte) === void 0 || (value == null ? void 0 : value.lte) >= max) {
      newMargin.lte = max;
    }
    if ((value == null ? void 0 : value.gte) === void 0 || (value == null ? void 0 : value.gte) <= min) {
      newMargin.gte = min;
    }
    return newMargin;
  }, [max, min, JSON.stringify(value)]);
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .useDevice */ .F)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputNumberGroups, {
    justify: "space-between",
    marginBottom: "s4"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, {
    value: margin.gte
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, {
    value: margin.lte
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .InputSlider */ .s, {
    range: true,
    size: isMobile ? _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.xl */ .mO.xl : _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.xs */ .mO.xs,
    min,
    max,
    step,
    value: [margin.gte, margin.lte],
    onChange: ([gte, lte]) => {
      const value2 = {
        lte: Math.min(lte, max),
        gte: Math.max(gte, min)
      };
      onFilter == null ? void 0 : onFilter(value2.gte, value2.lte);
    },
    changeOn: "dragend"
  }));
};
const Wrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Shape */ .b)``;
const InputNumberGroups = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k)(({ theme }) => `
  position: relative;
  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 0px;
    border-top: 1px solid ${theme.colors.divider};
    top:50%;
    z-index: 0;
  }
`);
const StyledCurrency = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Currency */ .F)(({ theme }) => `
  width: 75px;
  padding: 0.25rem;
  border: 1px solid ${theme.colors.divider};
  font-size: 0.7rem;
  border-radius: ${theme.borderRadius.s};
  background-color: ${theme.colors.white};
  z-index: 0;
  text-align: center;
`);




/***/ }),

/***/ 228576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useSearchAlgo; }
/* harmony export */ });
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(185081);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(353632);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(788813);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(504133);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);





// hook use mainly for A/B testing new discovery search algorithm
const useSearchAlgo = ()=>{
    const { enableSearchAlgoABTesting  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    const noDefaultSortOption = (0,helpers__WEBPACK_IMPORTED_MODULE_3__/* .getEnv */ .dU)("SEARCH_ALGO_NO_DEFAULT_SORT_OPTION") || "";
    const getSearchAlgoFromCookie = ()=>{
        var ref;
        return (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .isServerless */ .ep)() && !!enableSearchAlgoABTesting && !(0,helpers__WEBPACK_IMPORTED_MODULE_5__/* .checkCurrentPageIsExcluded */ .RN)(router.pathname) ? (ref = (0,helpers__WEBPACK_IMPORTED_MODULE_3__/* .getCookieByName */ .A7)(constants_index__WEBPACK_IMPORTED_MODULE_6__/* .SEARCH_ALGO.COOKIE */ .XH.COOKIE)) === null || ref === void 0 ? void 0 : ref.replace(constants_index__WEBPACK_IMPORTED_MODULE_6__/* .SEARCH_ALGO.REPLACE_PATTERN */ .XH.REPLACE_PATTERN, "") : undefined;
    };
    const noActiveDefaultSortOption = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return noDefaultSortOption === "enabled" && !(0,helpers__WEBPACK_IMPORTED_MODULE_5__/* .checkCurrentPageIsExcluded */ .RN)(router.pathname);
    }, [
        noDefaultSortOption,
        router.pathname
    ]);
    const getDefaultSortOption = (defaultSortOptionCode)=>{
        return !!noActiveDefaultSortOption ? undefined : defaultSortOptionCode;
    };
    return {
        noActiveDefaultSortOption,
        getSearchAlgoFromCookie,
        getDefaultSortOption
    };
};


/***/ }),

/***/ 814342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ ProductListWithFilter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _tekface_smart_activation__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(560327);
/* harmony import */ var _teko_discovery_v2__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(912885);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(982226);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(408797);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(212808);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(622746);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(241291);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(68018);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(428247);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(77322);
/* harmony import */ var _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(285212);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(775002);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(593859);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(927250);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(933756);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(681889);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(684443);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(268055);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88837);
/* harmony import */ var hooks_useSearchAlgo__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(228576);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(634655);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(891987);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(124177);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(185081);
/* harmony import */ var _hooks_useFilter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(409122);
/* harmony import */ var _shared_helpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(774608);
/* harmony import */ var _shared_styles__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(207971);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  margin: 0;\n  font-size: 1.5rem;\n  line-height: 2rem;\n  font-weight: 700;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 64px;\n  border-bottom: 1px solid #eaeaea;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  justify-content: space-between;\n  font-size: 14px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 4rem;\n  margin-bottom: 4rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  max-width: 100%;\n  margin-bottom: 24px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  .glide__bullets--override {\n    bottom: 1.5rem !important;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






















const SubSection = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(90400), __webpack_require__.e(54211)]).then(__webpack_require__.bind(__webpack_require__, 854211)).then((mod)=>mod.SubSection), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(854211)
            ]
    }
});
const NoProductsFound = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(27953), __webpack_require__.e(20493), __webpack_require__.e(90400), __webpack_require__.e(29078), __webpack_require__.e(91592), __webpack_require__.e(81633), __webpack_require__.e(22859), __webpack_require__.e(2026), __webpack_require__.e(61431), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(29021)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.NoProductsFound), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const ProductList = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(27953), __webpack_require__.e(20493), __webpack_require__.e(90400), __webpack_require__.e(29078), __webpack_require__.e(91592), __webpack_require__.e(81633), __webpack_require__.e(22859), __webpack_require__.e(2026), __webpack_require__.e(61431), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(29021)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.ProductList), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const ProductGrid = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(27953), __webpack_require__.e(20493), __webpack_require__.e(90400), __webpack_require__.e(29078), __webpack_require__.e(91592), __webpack_require__.e(81633), __webpack_require__.e(22859), __webpack_require__.e(2026), __webpack_require__.e(61431), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(29021)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.ProductGrid), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const DiscoveryRecommendedProducts = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(29078), __webpack_require__.e(22859), __webpack_require__.e(10769), __webpack_require__.e(15305)]).then(__webpack_require__.bind(__webpack_require__, 910769)).then((mod)=>mod.DiscoveryRecommendedProducts), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(910769)
            ]
    }
});
const ProductCarouselWithHeader = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(27953), __webpack_require__.e(20493), __webpack_require__.e(90400), __webpack_require__.e(29078), __webpack_require__.e(91592), __webpack_require__.e(81633), __webpack_require__.e(22859), __webpack_require__.e(2026), __webpack_require__.e(61431), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(29021)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.ProductCarouselWithHeader), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const BannerSlides = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(90400), __webpack_require__.e(39559)]).then(__webpack_require__.bind(__webpack_require__, 339559)).then((mod)=>mod.BannerSlides), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(339559)
            ]
    }
});
const NUMBER_OF_FEATURED_PRODUCTS_PER_ROW = 5;
const BANNER_SLIDERS_IMAGE_HEIGHT = 250;
const ProductListWithFilter = (_param)=>{
    var { siteTitle , serverProducts , serverFilters ={} , serverPagination , filterPrice , serverSeoInfo , customerParams , featuredProducts , inlineBanners  } = _param, props = _objectWithoutProperties(_param, [
        "siteTitle",
        "serverProducts",
        "serverFilters",
        "serverPagination",
        "filterPrice",
        "serverSeoInfo",
        "customerParams",
        "featuredProducts",
        "inlineBanners"
    ]);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const { query , asPath  } = router;
    const { showCollectionPageTitle , defaultSortOptionCode , addSchemaItemList , baseDomain , meta , sortByCreatedAt , displayFilterTypeCategory , subSections ,  } = (0,hooks__WEBPACK_IMPORTED_MODULE_6__/* .useTenantConfig */ .Wx)();
    let clientFilterPrice = filterPrice;
    const { 0: newQuery , 1: setNewQuery  } = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(query);
    const { clearFilterLink , getActiveFilterOptions , onClickFilterOption , onSortByPrice , onSortOptionSelected , getActiveCategories , onClickCategoriesFilterOption , onRemoveCategory ,  } = (0,_hooks_useFilter__WEBPACK_IMPORTED_MODULE_7__/* .useFilter */ .L)(newQuery, setNewQuery, {
        autoSubmit: true
    });
    const { getSearchAlgoFromCookie , getDefaultSortOption  } = (0,hooks_useSearchAlgo__WEBPACK_IMPORTED_MODULE_8__/* .useSearchAlgo */ .t)();
    const { trackingScreenName  } = (0,contexts__WEBPACK_IMPORTED_MODULE_9__/* .useScreen */ .EV)();
    let filters = serverFilters;
    const { pos365StoreCode  } = (0,hooks__WEBPACK_IMPORTED_MODULE_10__/* .usePos365StoreCode */ .c)();
    const slug = (0,_shared_helpers__WEBPACK_IMPORTED_MODULE_11__/* .getCollectionSlug */ .I_)(query.slug);
    const { providerId , sellerId , brandId , brands  } = query;
    // to avoid sending duplicate GTM events
    const { 1: setProductSkuList  } = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([]);
    const bannerClassname = slug ? _constants__WEBPACK_IMPORTED_MODULE_12__/* .INLINE_BANNER_CLASSNAME.INLINE_CATEGORY */ .h.INLINE_CATEGORY : brandId ? _constants__WEBPACK_IMPORTED_MODULE_12__/* .INLINE_BANNER_CLASSNAME.INLINE_BRAND */ .h.INLINE_BRAND : sellerId ? _constants__WEBPACK_IMPORTED_MODULE_12__/* .INLINE_BANNER_CLASSNAME.INLINE_SELLER */ .h.INLINE_SELLER : trackingScreenName === "searchProductResult" ? _constants__WEBPACK_IMPORTED_MODULE_12__/* .INLINE_BANNER_CLASSNAME.INLINE_SEARCH */ .h.INLINE_SEARCH : null;
    const { 0: queryPage , 1: setPage  } = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(parseInt(query === null || query === void 0 ? void 0 : query.page) || 1);
    const { 0: { displayProducts , hasmore  } , 1: setProductWithPagination  } = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)({
        displayProducts: serverProducts || [],
        hasmore: ((serverPagination === null || serverPagination === void 0 ? void 0 : serverPagination.totalItems) || 0) > (queryPage || 1) * _constants__WEBPACK_IMPORTED_MODULE_13__/* .ITEM_PER_PAGE_IN_LISTING_PAGE */ .p9
    });
    // sort
    const activeSortOption = (0,_shared_helpers__WEBPACK_IMPORTED_MODULE_11__/* .getActiveSortOption */ .j3)(query, sortByCreatedAt, getDefaultSortOption(defaultSortOptionCode));
    const [sort, order] = activeSortOption ? (0,_shared_helpers__WEBPACK_IMPORTED_MODULE_11__/* .extractSortQuery */ .To)(activeSortOption.optionCode) : [
        undefined,
        undefined
    ];
    const payloadFilters = _objectSpread({
        // brandId --> case brand page, example: /asus-brand.asus
        // brands --> case filter brand: example: /search?router=productListing&query=áo&brands=aimer%2Cbare
        brands: brandId ? typeof brandId === "string" ? [
            brandId
        ] : [
            ...brandId
        ] : brands,
        // seller page: /*-sel.:sellerId
        sellerIds: sellerId && [
            sellerId
        ],
        // provider page: /cua-hang/335?pageTitle=Takashimaya%20Official%20Store
        providerIds: providerId && [
            providerId
        ]
    }, customerParams, query);
    const { isLoading , result , transformProduct  } = (0,hooks__WEBPACK_IMPORTED_MODULE_14__/* .useSearch */ .Rx)((0,_teko_utils__WEBPACK_IMPORTED_MODULE_15__.cleanObject)({
        page: queryPage,
        pageSize: _constants__WEBPACK_IMPORTED_MODULE_13__/* .ITEM_PER_PAGE_IN_LISTING_PAGE */ .p9,
        slug,
        query: query.query,
        filter: (0,helpers__WEBPACK_IMPORTED_MODULE_16__/* .convertToPayloadFilter */ .JR)(payloadFilters),
        sorting: (0,helpers__WEBPACK_IMPORTED_MODULE_16__/* .convertToPayloadSorting */ .EN)(sort, order),
        returnFilterable: [],
        isNeedFeaturedProducts: !!slug
    }), {
        products: serverProducts,
        pagination: serverPagination,
        filters: {},
        seoInfo: serverSeoInfo
    }, {
        onSuccess: (param)=>{
            let { products , pagination  } = param;
            var ref;
            const isFirstPage = queryPage === (parseInt(query === null || query === void 0 ? void 0 : query.page) || 1);
            /** send tracking event with search result data when:
          - query string exists
          - in a search result page & not a collection page (/c/*)
          - is the first result page
        */ if (!!((ref = query.query) === null || ref === void 0 ? void 0 : ref.length) && isFirstPage) {
                (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_17__/* .trackCustomEvent */ .I)("siteSearchResult", {
                    action: "search",
                    category: getSearchAlgoFromCookie() || undefined,
                    label: query.query.toString(),
                    property: JSON.stringify({
                        products: products.map((product)=>product.sku),
                        filter: (0,helpers__WEBPACK_IMPORTED_MODULE_16__/* .convertToPayloadFilter */ .JR)(payloadFilters)
                    })
                });
            }
            setProductWithPagination((currentState)=>{
                return {
                    displayProducts: [
                        ...isFirstPage ? [] : currentState.displayProducts,
                        ...products, 
                    ],
                    hasmore: ((pagination === null || pagination === void 0 ? void 0 : pagination.totalItems) || 0) > (queryPage || 1) * _constants__WEBPACK_IMPORTED_MODULE_13__/* .ITEM_PER_PAGE_IN_LISTING_PAGE */ .p9
                };
            });
        }
    }, getSearchAlgoFromCookie());
    const { pagination , products , seoInfo  } = result || {};
    const { totalItems , totalPages  } = pagination || {};
    const listProducts = displayProducts.map((product)=>transformProduct(product));
    const { result: filterResult  } = (0,hooks__WEBPACK_IMPORTED_MODULE_14__/* .useSearch */ .Rx)(// currently, only serverside render filter for collection and brand page
    !slug && !brandId ? (0,_teko_utils__WEBPACK_IMPORTED_MODULE_15__.cleanObject)({
        slug,
        query: query.query,
        filter: !query.query ? (0,helpers__WEBPACK_IMPORTED_MODULE_16__/* .convertToPayloadFilter */ .JR)((0,_shared_helpers__WEBPACK_IMPORTED_MODULE_11__/* .getSignatureQueryParam */ .xP)(query)) : {},
        returnFilterable: displayFilterTypeCategory ? _teko_discovery_v2__WEBPACK_IMPORTED_MODULE_18__/* .EXTENDED_RETURN_FILTERABLE */ .O1 : _teko_discovery_v2__WEBPACK_IMPORTED_MODULE_18__/* .DEFAULT_RETURN_FILTERABLE */ .wC,
        pageSize: 1
    }) : {}, {
        products: [],
        pagination: serverPagination,
        filters: serverFilters
    }, undefined, getSearchAlgoFromCookie());
    // currently, only serverside render filter for collection and brand page
    if (!slug && !brandId) {
        var ref, ref1;
        clientFilterPrice = {
            max: (filterResult === null || filterResult === void 0 ? void 0 : (ref = filterResult.filters) === null || ref === void 0 ? void 0 : ref.priceLte) || 10000000,
            min: (filterResult === null || filterResult === void 0 ? void 0 : (ref1 = filterResult.filters) === null || ref1 === void 0 ? void 0 : ref1.priceGte) || 0
        };
        filters = filterResult === null || filterResult === void 0 ? void 0 : filterResult.filters;
    }
    const categoriesFilters = (0,helpers__WEBPACK_IMPORTED_MODULE_16__/* .buildTreeCategoriesFilter */ .yr)(filters.categories || []);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        // reset page on query change
        setPage(parseInt(query === null || query === void 0 ? void 0 : query.page) || 1);
    }, [
        query
    ]);
    // send GTM track view product list event
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        (0,_teko_utils__WEBPACK_IMPORTED_MODULE_19__/* .scheduleTaskInIdleTime */ .D_)(()=>{
            setProductSkuList((prevSkuList)=>{
                var ref;
                const newSkuList = (ref = products === null || products === void 0 ? void 0 : products.map((product)=>product.sku || "")) !== null && ref !== void 0 ? ref : [];
                // check if these 2 arrays are different
                const different = prevSkuList.length !== (newSkuList === null || newSkuList === void 0 ? void 0 : newSkuList.length) || prevSkuList.find((sku)=>!newSkuList.includes(sku));
                if (different) {
                    var ref1;
                    (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_20__/* .trackViewProductList */ .u)((ref1 = products === null || products === void 0 ? void 0 : products.map((product)=>({
                            sku: product.sku || ""
                        }))) !== null && ref1 !== void 0 ? ref1 : []);
                    return newSkuList;
                }
                return prevSkuList;
            });
        }, 3000);
    }, [
        products
    ]);
    // filter price
    const { price_gte ="" , price_lte =""  } = query;
    const { priceGte , priceLte , priceFilter  } = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(()=>{
        const priceFilter = (0,_shared_helpers__WEBPACK_IMPORTED_MODULE_11__/* .cookFilterPrice */ .kr)(clientFilterPrice === null || clientFilterPrice === void 0 ? void 0 : clientFilterPrice.max);
        return {
            priceGte: price_gte ? (0,_teko_utils__WEBPACK_IMPORTED_MODULE_21__/* .stringToInteger */ .C)(price_gte.toString()) : priceFilter.min,
            priceLte: price_lte ? (0,_teko_utils__WEBPACK_IMPORTED_MODULE_21__/* .stringToInteger */ .C)(price_lte.toString()) : priceFilter.max,
            priceFilter
        };
    }, [
        price_gte,
        price_lte,
        clientFilterPrice === null || clientFilterPrice === void 0 ? void 0 : clientFilterPrice.max
    ]);
    // PageAbove contain: page title, bannersliders, subsection
    const renderPageAbove = ()=>{
        var ref, ref1, ref2, ref3, ref4;
        const showPageTitle = !!showCollectionPageTitle && !!siteTitle;
        const subSectionFromWorkload = (subSections === null || subSections === void 0 ? void 0 : subSections[slug]) ? (0,_shared_helpers__WEBPACK_IMPORTED_MODULE_11__/* .convertSubsections */ .qh)(subSections === null || subSections === void 0 ? void 0 : subSections[slug]) : [];
        const subsectionsData = !!(seoInfo === null || seoInfo === void 0 ? void 0 : (ref = seoInfo.subsections) === null || ref === void 0 ? void 0 : ref.length) ? seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.subsections : subSectionFromWorkload;
        const desktopBannerSliders = seoInfo === null || seoInfo === void 0 ? void 0 : (ref1 = seoInfo.bannerSliders) === null || ref1 === void 0 ? void 0 : ref1.find((param)=>{
            let { type  } = param;
            return type === "DESKTOP";
        });
        const showPageAbove = showPageTitle || !!(subsectionsData === null || subsectionsData === void 0 ? void 0 : subsectionsData.length) || !!(desktopBannerSliders === null || desktopBannerSliders === void 0 ? void 0 : (ref2 = desktopBannerSliders.items) === null || ref2 === void 0 ? void 0 : ref2.length);
        if (!showPageAbove) return null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_22__/* .Shape */ .b, {
            backgroundColor: "white",
            padding: [
                "s12",
                "s16"
            ],
            marginBottom: !(featuredProducts === null || featuredProducts === void 0 ? void 0 : (ref3 = featuredProducts.products) === null || ref3 === void 0 ? void 0 : ref3.length) ? "s4" : "s0",
            children: [
                showPageTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(PageTitleContainer, {
                    justify: "start",
                    align: "baseline",
                    borderRadius: "m",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageTitle, {
                            children: siteTitle
                        }),
                        totalItems != undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_23__/* .Title */ .Dx, {
                            color: "textSecondary",
                            paddingLeft: "s8",
                            weight: "regular",
                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_24__.t)("({{quantity}} sản phẩm)", {
                                quantity: totalItems
                            })
                        })
                    ]
                }),
                !!(desktopBannerSliders === null || desktopBannerSliders === void 0 ? void 0 : (ref4 = desktopBannerSliders.items) === null || ref4 === void 0 ? void 0 : ref4.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledBannerSlidesWrapper, {
                    marginTop: showPageTitle ? "s8" : "s0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BannerSlides, {
                        banners: desktopBannerSliders === null || desktopBannerSliders === void 0 ? void 0 : desktopBannerSliders.items.map((item, index)=>({
                                id: "".concat(index).concat(item.linkUrl),
                                targetPath: item.linkUrl,
                                image: item.thumbnailUrl
                            })),
                        prioritized: true,
                        showControl: true,
                        imageHeight: BANNER_SLIDERS_IMAGE_HEIGHT
                    })
                }),
                !!(subsectionsData === null || subsectionsData === void 0 ? void 0 : subsectionsData.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SubSection, {
                    subsections: subsectionsData
                })
            ]
        });
    };
    // render featured products block
    const renderFeaturedProducts = ()=>{
        var ref;
        if (!(featuredProducts === null || featuredProducts === void 0 ? void 0 : (ref = featuredProducts.products) === null || ref === void 0 ? void 0 : ref.length)) return null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_22__/* .Shape */ .b, {
            marginBottom: "s24",
            backgroundColor: "white",
            padding: "s16",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductCarouselWithHeader, {
                header: featuredProducts.blockTitle ? {
                    title: featuredProducts.blockTitle,
                    titleColor: "white",
                    style: {
                        justifyContent: "center"
                    }
                } : undefined,
                productsPerRow: NUMBER_OF_FEATURED_PRODUCTS_PER_ROW,
                products: featuredProducts.products,
                background: featuredProducts.backgroundImageUrl,
                style: {
                    borderRadius: "4px",
                    // add top padding only when
                    // - block title not exists
                    // - block background image exists
                    paddingTop: !!featuredProducts.blockTitle || !featuredProducts.backgroundImageUrl ? "0px" : "3.5rem"
                }
            })
        });
    };
    // render sort bar
    const renderSortBar = ()=>{
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SortBarWrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_25__/* .Flex */ .k, {
                justify: "center",
                align: "center",
                height: "100%",
                paddingLeft: "s16",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_23__/* .SubTitle */ .DK, {
                        marginRight: "s32",
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_24__.t)("Sắp xếp theo")
                    }),
                    (0,_shared_helpers__WEBPACK_IMPORTED_MODULE_11__/* .getDefaultSortOptions */ .Fb)(sortByCreatedAt).map((option, index)=>{
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_26__/* .SelectionOption */ .J, {
                            iconActiveSize: _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.xs */ .mO.xs,
                            block: false,
                            isActive: (activeSortOption === null || activeSortOption === void 0 ? void 0 : activeSortOption.optionCode) === option.optionCode,
                            onClick: ()=>onSortOptionSelected(option),
                            style: {
                                padding: "0.5rem",
                                marginRight: "1rem"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_23__/* .Body */ .uT, {
                                level: 1,
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_24__.t)(option.optionName)
                            })
                        }, index);
                    })
                ]
            })
        });
    };
    // render product list
    const renderProductList = ()=>{
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                !(listProducts === null || listProducts === void 0 ? void 0 : listProducts.length) && !isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledNoProductsFound, {
                            show: !isLoading && !(listProducts === null || listProducts === void 0 ? void 0 : listProducts.length)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledContainer, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DiscoveryRecommendedProducts, {})
                        })
                    ]
                }),
                !!pos365StoreCode ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductList, {
                    products: listProducts,
                    regionName: "itemProductResult",
                    itemsPerPage: Math.ceil(totalItems / totalPages) || _constants__WEBPACK_IMPORTED_MODULE_13__/* .ITEM_PER_PAGE_IN_LISTING_PAGE */ .p9
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductGrid, {
                    products: listProducts,
                    regionName: "itemProductResult",
                    itemsPerPage: Math.ceil(totalItems / totalPages) || _constants__WEBPACK_IMPORTED_MODULE_13__/* .ITEM_PER_PAGE_IN_LISTING_PAGE */ .p9
                })
            ]
        });
    };
    const renderViewMore = ()=>{
        if (!hasmore) {
            return null;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_25__/* .Flex */ .k, {
            justify: "center",
            marginBottom: "s8",
            width: "100%",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_styles__WEBPACK_IMPORTED_MODULE_27__/* .ShowMoreButton */ .K, {
                variant: "link",
                suffix: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_28__/* .ForwardOutlined */ .d, {}),
                disabled: isLoading,
                onClick: (e)=>{
                    setPage((page)=>page + 1);
                    e === null || e === void 0 ? void 0 : e.preventDefault();
                },
                children: (0,i18n__WEBPACK_IMPORTED_MODULE_24__.t)("Xem th\xeam sản phẩm")
            })
        });
    };
    const queryOmitSlug = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(()=>_objectSpread({}, query), [
        query
    ]);
    delete queryOmitSlug.slug;
    const productsSchema = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(()=>!Object.keys(queryOmitSlug).length || Object.keys(queryOmitSlug).length === 1 && Number(queryOmitSlug.page) === 1 ? listProducts : [], [
        queryOmitSlug,
        listProducts
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            addSchemaItemList && !!(productsSchema === null || productsSchema === void 0 ? void 0 : productsSchema.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "ItemList",
                            name: serverSeoInfo === null || serverSeoInfo === void 0 ? void 0 : serverSeoInfo.siteTitle,
                            url: "".concat(baseDomain).concat(asPath),
                            description: (serverSeoInfo === null || serverSeoInfo === void 0 ? void 0 : serverSeoInfo.description) || meta.description,
                            itemListElement: productsSchema.map((product, index)=>{
                                var ref, ref1;
                                return {
                                    "@type": "ListItem",
                                    position: index + 1,
                                    item: {
                                        name: product.name,
                                        url: baseDomain + ((ref1 = (ref = product.link) === null || ref === void 0 ? void 0 : ref.as) === null || ref1 === void 0 ? void 0 : ref1.pathname)
                                    }
                                };
                            })
                        })
                    }
                })
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_29__/* .Container */ .W, _objectSpreadProps(_objectSpread({}, props), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_30__/* .Row */ .X, {
                    gutter: [
                        16,
                        16
                    ],
                    marginBottom: "s16",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_31__/* .Col */ .JX, {
                            span: 2,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_32__/* .VerticalFilter */ .p, {
                                activeOptions: getActiveFilterOptions((0,helpers__WEBPACK_IMPORTED_MODULE_16__/* .convertDiscoveryFilter */ .px)(filters, displayFilterTypeCategory)),
                                filters: (0,_shared_helpers__WEBPACK_IMPORTED_MODULE_11__/* .getDisplayFilter */ .Ou)((0,helpers__WEBPACK_IMPORTED_MODULE_16__/* .convertDiscoveryFilter */ .px)(filters, displayFilterTypeCategory)),
                                onClickOption: onClickFilterOption,
                                clearFilterLink: {
                                    href: clearFilterLink
                                },
                                filterPrice: priceFilter ? {
                                    max: priceFilter.max,
                                    min: priceFilter.min,
                                    step: priceFilter.step,
                                    value: {
                                        gte: priceGte,
                                        lte: priceLte
                                    },
                                    onFilter: onSortByPrice
                                } : undefined,
                                // for categories filter
                                categoriesFilter: categoriesFilters.length ? {
                                    filterName: "Danh mục sản phẩm",
                                    filterOptions: categoriesFilters,
                                    onClickCategoryOption: (option)=>onClickCategoriesFilterOption(option, categoriesFilters),
                                    activeOptions: getActiveCategories(categoriesFilters),
                                    onRemoveCategory: onRemoveCategory
                                } : undefined
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_31__/* .Col */ .JX, {
                            span: 10,
                            children: [
                                bannerClassname ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tekface_smart_activation__WEBPACK_IMPORTED_MODULE_33__/* .BannerInlinePlaceholder */ .Q, {
                                    banners: inlineBanners,
                                    className: bannerClassname
                                }) : null,
                                renderPageAbove(),
                                renderFeaturedProducts(),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_22__/* .Shape */ .b, {
                                    backgroundColor: "white",
                                    width: "100%",
                                    borderRadius: "m",
                                    children: [
                                        renderSortBar(),
                                        renderProductList()
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_30__/* .Row */ .X, {
                                    marginTop: "s16",
                                    children: renderViewMore()
                                })
                            ]
                        })
                    ]
                })
            }))
        ]
    });
};
const PageTitleContainer = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_34__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_30__/* .Row */ .X)(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
});
const PageTitle = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_34__["default"].h1(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.colors.textPrimary;
});
const SortBarWrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_34__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_25__/* .Flex */ .k)(_templateObject2());
const StyledNoProductsFound = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_34__["default"])(NoProductsFound)(_templateObject3());
const StyledContainer = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_34__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_29__/* .Container */ .W)(_templateObject4());
const StyledBannerSlidesWrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_34__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_22__/* .Shape */ .b)(_templateObject5());


/***/ })

}]);